<template>
<div v-if="success == false">
  <div class="popupStyle-layout-1" style="height: auto; font-family: NanumSquareOTF;">
    <div class="title" style="margin-bottom: 44px;">
      정비·수리 예약신청
    </div>
    <div class="subtitle">
      예약신청을 남겨주시면 담당자가 카센터에 연락하여 예약 일정을 조율한 후 확정일정을 안내드립니다.
    </div>
    <div class="title-area mb-32 mx-20" style="margin-bottom: 20px;">
      <h4 style="font-weight:bold; color:#666666;">상호명 </h4>
      <element-select
        style="margin-top:-10px;"
        v-model="selectedStore"
        :items="storeInfo.items"
      ></element-select>
    </div>

    <div class="title-area mb-32 mx-20" style="margin-bottom: 20px;">
      <h4 style="font-weight:bold; color:#666666;">예약 희망일시</h4>
      <div class="reservation-datebox">
        <div class="reservation-datepick">
          <Calendar v-model="selectedDate" />
        </div>
        <element-select
          class="reservation-datetime"
          v-model="selectedTime"
          :items="timeInfo.items"
        ></element-select>
      </div>
    </div>

    <div class="title-area mb-32 mx-20">
      <h4 style="font-weight:bold; color:#666666;">연락받을 휴대폰번호 </h4>
      <input
        class="input-box-border"
        v-model="phoneNumber"
        type="text"
        disabled
        placeholder="휴대폰번호를 입력해주세요"
      />
    </div>

    <div class="title-area mb-32 mx-20" style="margin-top: 30px; margin-bottom: 100px;">
      <h4 style="font-weight:bold; color:#666666;">남기실 말씀 </h4>
      <textarea
        class="textarea-box-border"
        v-model="textAreaText"
        type="text"
        maxlength="500"
        rows="5"
        placeholder="예약 희망일정 추가, 정비 희망내역 추가 등 예약 관련 남기실 말씀이 있다면 입력해주세요"
      ></textarea>
    </div>

  </div>
  <!-- 하단부 버튼 -->
  <ButtonBottom
    v-if="btnDisabled === true"
    btnTitle="등록"
    :disabled="true"
    class="submit-btn"
    :click="clickNo">
  </ButtonBottom>
  <ButtonBottom
    v-else-if="btnDisabled === false"
    btnTitle="등록"
    :disabled="false"
    class="submit-btn"
    :click="clickApply">
  </ButtonBottom>
</div>
<!-- 신청 완료시 완료 화면 -->
  <Success v-else-if="success === true"
    contents="정비·수리 예약을<br>신청했습니다."
    contentsWeak="예약일정이 확정되면<br>입력하신 휴대폰번호로 안내드립니다."
    :customOK="clickOkay">
  </Success>
</template>

<script>
import ButtonBottom from '@/components/Elements/ButtonBottom';
import Calendar from '@/components/Elements/Calendar';
import Success from '@/components/Elements/Success';

export default {
  components: { ButtonBottom, Success, Calendar },
  data() {
    return {
      repairEstimateCompare: {},
      success: false,
      dialog: false,
      btnDisabled: true,
      // 가게 상호
      selectedStore: '',
      storeInfo: {
        items: []
      },
      timeInfo: {
        items: [
          { value: '오전', label: '오전' },
          { value: '오후', label: '오후' },
          { value: '전일', label: '전일' },
        ]
      },
      // 예약 희망일시
      selectedDate: '',
      selectedTime: '오전',
      // 휴대폰 번호
      phoneNum: '',
      // 남기신 말씀
      textAreaText: '',
    }
  },
  created() {
    if (this.$store.state.customer.profile.customer_phone_number !== '') {
      this.phoneNum = this.$store.state.customer.profile.customer_phone_number || ''
    }
    this.get_repair_estimate_compare()
  },
  watch: {
    selectedDate () {
      if ( this.selectedDate ) {
        this.btnDisabled = false
      }
    }
  },
  computed: {
    phoneNumber () {
	    return this.phoneNum.replace(/(^02.{0}|^01.{1}|^[0-9]{3})([0-9]*)([0-9]{4})/, "$1-$2-$3");
    }
  },
  methods: {
    get_repair_estimate_compare() {      
      return this.$store.dispatch('repair/getCompareItem', { repairCompareId: this.$route.query.repairCompareId })
        .then(({data}) => {
          this.repairEstimateCompare = data.data
          this.get_repair_estimate_compares(data.data.repair_estimate_id)
          this.selectedStore = this.$route.query.companyId
        })
    },
    get_repair_estimate_compares(repair_estimate_id) {
      return this.$store.dispatch(`repair/getCompareItems`, { repairId: repair_estimate_id })
                .then(({data}) => {
                  this.storeInfo.items = data.data.items.map(datum => ({
                    price: datum.amount,
                    label: datum.company_name,
                    detail: datum.memo,
                    address: datum.address,
                    phone: datum.tel_number,
                    _id: datum._id,
                    value: datum.company_id
                  }))
                  return data
                })
    },
    clickNo () {
      return ;
    },
    clickApply () {
      const params = {
        repairEstimateId: this.repairEstimateCompare.repair_estimate_id,
        data: {
          desired_company: this.selectedStore,
          desired_reservation_date: this.selectedDate,
          desired_reservation_date_ampm: this.selectedTime,
          reservation_memo: this.textAreaText,
          repair_estimate_status: '예약요청'
        }
      };

      this.$store.dispatch('repair/edit', params).then(() => {
        this.success = true
      })
    },
    clickOkay() {
      window.location.href = '/'
    }
  },
}
</script>

<style lang="scss">
.reservation-datebox {
  display: flex;
  /* flex-direction: row; */
  justify-content: space-between;

  .reservation-datepick {
    width: 49%;
  }
  .reservation-datetime {
    width: 49%;
  }
}
.subtitle {
  color: #666666;
  margin-top: -20px;
  margin-bottom: 40px;
}
.textarea-box-border {
  border-radius: 2px;
  margin-top: 5px;
  margin-bottom: 30px;
  border: 1px solid #D9D9D9;
  padding: 10px 15px 10px 15px;
}
.input-box-border {
  background-color: #F2F2F2;
  height: 54px;
  font-weight: bold;
  border-radius: 2px;
  margin-top: 5px;
  border: 1px solid #D9D9D9;
  padding: 10px 15px 10px 15px;
}
</style>
